export default __webpack_public_path__ + "static/media/over-theMoon.2332c560.webp";